import i18n from '@/i18n';
export default [
    {
        get text() {
            return i18n?.global?.t('tableHeaders.id');
        },
        value: 'id',
    },
    {
        get text() {
            return i18n?.global?.t('tableHeaders.name');
        },
        value: 'name',
    },
    {
        get text() {
            return i18n?.global?.t('common.map');
        },
        value: 'map',
    },
    { value: 'operation', fixed: true, width: 54 },
];
